export default __webpack_public_path__ + "static/media/Fiction_Logo_Full_Red.d867270d.png";